import { motion } from "framer-motion";
import { ShieldCheck, Compass, Users, GraduationCap, Sparkles } from "lucide-react";

const COMMITMENTS = [
  { icon: Sparkles, label: "Original instruction" },
  { icon: GraduationCap, label: "Professional standards" },
  { icon: ShieldCheck, label: "Safety-first thinking" },
  { icon: Users, label: "Respect for people, property & airspace" },
  { icon: Compass, label: "Lifelong learning" },
];

export const AcademyPromise = () => (
  <motion.section
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    className="relative mb-10 rounded-sm border border-primary/25 bg-gradient-to-b from-primary/5 to-transparent overflow-hidden"
    data-testid="dronacademy-promise"
  >
    <div className="px-6 py-8 md:px-10 md:py-10">
      <span className="text-xs font-mono uppercase tracking-[0.3em] text-primary">The DronAcademy Promise</span>
      <p className="mt-4 text-lg md:text-xl text-slate-100 font-display leading-relaxed max-w-3xl">
        Great pilots are made through knowledge, preparation, and sound judgment.
      </p>
      <p className="mt-4 text-[15px] text-slate-300 leading-relaxed max-w-3xl">
        Every lesson is created from original instructional content, designed to reflect current FAA guidance
        where applicable, and built to help you become a safer, more capable drone pilot. We don't teach
        shortcuts. We don't encourage unnecessary risks. We don't measure success by how high, how far, or how
        fast you can fly — we measure it by your ability to make informed decisions before, during, and after
        every flight.
      </p>

      <div className="mt-6 flex flex-wrap gap-3" data-testid="promise-commitments">
        {COMMITMENTS.map((c) => (
          <span key={c.label}
            className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider px-3 py-1.5 rounded-sm border border-border/70 bg-card text-slate-300">
            <c.icon className="h-3.5 w-3.5 text-primary" /> {c.label}
          </span>
        ))}
      </div>

      <div className="mt-7 pt-6 border-t border-primary/15">
        <p className="font-display text-base text-slate-200">Welcome to DronAcademy.</p>
        <p className="font-display font-black tracking-tight text-lg mt-1">
          <span className="text-primary">Learn.</span> <span className="text-white">Fly.</span>{" "}
          <span className="text-accent">Decide.</span>
        </p>
      </div>
    </div>
  </motion.section>
);
